var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.55 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12.16,18.75c-.14,0-.27-.05-.37-.15-.2-.2-.2-.53,0-.73l8.5-8.5L11.8.87c-.2-.21-.18-.54.03-.73.2-.19.51-.19.71,0l8.87,8.87c.2.2.2.53,0,.73,0,0,0,0,0,0l-8.87,8.87c-.1.1-.23.15-.37.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M21.03,9.89H.51C.23,9.88,0,9.65,0,9.36c0-.28.23-.51.51-.51h20.52c.29,0,.52.23.52.51,0,.29-.23.52-.51.52h-.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d13616f2.svg";
export { ForwardRef as ReactComponent };